/** The steps a research record can take after saving (each its own POST). */
export const RESEARCH_STEPS = ["submit", "withdraw", "approve", "reject", "reopen", "close"];
/** Route paths shared by the API (to register) and the client (to call). One source, no typos. */
export const API_PREFIX = "/api/v1";
export const AUTH_BASE_PATH = "/api/auth";
export const ROUTES = {
    healthLive: `${API_PREFIX}/health/live`,
    healthReady: `${API_PREFIX}/health/ready`,
    me: `${API_PREFIX}/me`,
    mePassword: `${API_PREFIX}/me/password`,
    users: `${API_PREFIX}/users`,
    user: (id) => `${API_PREFIX}/users/${encodeURIComponent(id)}`,
    userDeactivate: (id) => `${API_PREFIX}/users/${encodeURIComponent(id)}/deactivate`,
    userReactivate: (id) => `${API_PREFIX}/users/${encodeURIComponent(id)}/reactivate`,
    userPermissions: (id) => `${API_PREFIX}/users/${encodeURIComponent(id)}/permissions`,
    catalogCards: `${API_PREFIX}/catalog/cards`,
    searches: `${API_PREFIX}/searches`,
    research: `${API_PREFIX}/research`,
    researchRecord: (id) => `${API_PREFIX}/research/${encodeURIComponent(id)}`,
    researchByListing: `${API_PREFIX}/research/by-listing`,
    researchSummary: `${API_PREFIX}/research/summary`,
    researchBulk: `${API_PREFIX}/research/bulk`,
    cards: `${API_PREFIX}/cards`,
    cardRequests: `${API_PREFIX}/cards/requests`,
    cardListings: `${API_PREFIX}/cards/listings`,
    cardStats: `${API_PREFIX}/cards/stats`,
    cardPlatforms: `${API_PREFIX}/cards/platforms`,
    card: (id) => `${API_PREFIX}/cards/${encodeURIComponent(id)}`,
    cardLinks: (id) => `${API_PREFIX}/cards/${encodeURIComponent(id)}/links`,
    cardImage: (id) => `${API_PREFIX}/cards/${encodeURIComponent(id)}/image`,
    cardViewed: (id) => `${API_PREFIX}/cards/${encodeURIComponent(id)}/viewed`,
    cardClosed: (id) => `${API_PREFIX}/cards/${encodeURIComponent(id)}/closed`,
    cardLinkDeal: (id, linkId) => `${API_PREFIX}/cards/${encodeURIComponent(id)}/links/${encodeURIComponent(linkId)}/deal`,
    cardLink: (id, linkId) => `${API_PREFIX}/cards/${encodeURIComponent(id)}/links/${encodeURIComponent(linkId)}`,
    cardLinkStep: (id, linkId, step) => `${API_PREFIX}/cards/${encodeURIComponent(id)}/links/${encodeURIComponent(linkId)}/${step}`,
    notifications: `${API_PREFIX}/notifications`,
    notificationsRead: `${API_PREFIX}/notifications/read`,
    researchAssessment: (id) => `${API_PREFIX}/research/${encodeURIComponent(id)}/assessment`,
    researchPrice: (id) => `${API_PREFIX}/research/${encodeURIComponent(id)}/price`,
    /** POST: submit, withdraw, approve, reject, reopen, close. */
    researchStep: (id, step) => `${API_PREFIX}/research/${encodeURIComponent(id)}/${step}`,
    portfolio: `${API_PREFIX}/portfolio`,
    portfolioItem: (id) => `${API_PREFIX}/portfolio/${encodeURIComponent(id)}`,
    portfolioPhotos: (id) => `${API_PREFIX}/portfolio/${encodeURIComponent(id)}/photos`,
    portfolioPhoto: (id, photoId) => `${API_PREFIX}/portfolio/${encodeURIComponent(id)}/photos/${encodeURIComponent(photoId)}`,
    signIn: `${AUTH_BASE_PATH}/sign-in/email`,
    signOut: `${AUTH_BASE_PATH}/sign-out`,
};
//# sourceMappingURL=routes.js.map